var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"root-modal-target"}},[_c('div',{class:[ _vm.modalClass, _vm.genericClass ],attrs:{"data-test-id":"a-modal"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }